import { SortingState } from "@tanstack/react-table";
import { useState, useCallback } from "react";

export const useSortingWithFilter = (
  updateFilter: (filter: any) => void,
  columnMapping: Record<string, string>
) => {
  const [sorting, setSorting] = useState<SortingState>([]);

  const handleSortingChange = useCallback((updaterOrValue: any) => {
    setSorting((prevSorting) => {
      const newSorting = typeof updaterOrValue === 'function' 
        ? updaterOrValue(prevSorting)
        : updaterOrValue;
      
      if (newSorting.length > 0) {
        const { id, desc } = newSorting[0];
        const dbField = columnMapping[id] || id;
        
        updateFilter({ 
          key: 'orderBy', 
          value: { [dbField]: desc ? 'desc' : 'asc' }
        });
      } else {
        updateFilter({ 
          key: 'orderBy', 
          value: {}
        });
      }
      
      return newSorting;
    });
  }, [updateFilter, columnMapping]);

  return { sorting, handleSortingChange };
};